import settings from '/@/core/settings';
import { axFetch } from '../session/actions';

export const getCornDiseaseControlApplications = ({ page, pageSize = 10 }: { page?: number; pageSize?: number }) => {
    const params = new URLSearchParams();
    params.append('page', page?.toString() ?? '');
    params.append('page_size', pageSize?.toString() ?? '');

    return axFetch
        .get(`${settings.urls.apiDomain}/core/v1/pathologies/corn-disease-control/?${params}`)
        .then((res) => res.data);
};
